var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindADoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.8101,
    r: 17,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3469 26.5018C30.0212 26.5018 33 29.4354 33 33.0541V36.982C33 37.4389 32.6232 37.8099 32.1593 37.8099H7.84069C7.37677 37.8099 7 37.4389 7 36.982V33.0541C7 29.4354 9.97878 26.5018 13.6531 26.5018H26.3469Z",
    fill: "#4DAADD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7284 26.6344C19.7089 29.5543 19.9075 29.9625 13.8191 26.6448C13.7105 26.5855 13.7082 26.4321 13.8155 26.3704L15.7689 25.2474C16.1901 25.0399 16.4561 24.6161 16.4561 24.153V21.2777L23.2747 21.3156V24.153C23.2747 24.6161 23.5407 25.0399 23.962 25.2474L25.7438 26.3596C25.8493 26.4255 25.8405 26.58 25.7284 26.6344Z",
    fill: "#FFB59E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59136 33.0546V36.9821C8.59136 37.4391 8.9682 37.8102 9.43224 37.8102H7.84088C7.37683 37.8102 7 37.4391 7 36.9821V33.0546C7 29.4355 9.97903 26.5023 13.6532 26.5023H15.2445C11.5704 26.5023 8.59136 29.4355 8.59136 33.0546Z",
    fill: "#99DDF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4463 28.9059C18.6933 29.2313 17.2426 28.5141 13.5723 26.51L15.769 25.2474C16.1897 25.0399 16.4558 24.6161 16.4558 24.1528V21.2773L18.0472 21.2861V24.1528C18.0472 24.6161 17.7811 25.0399 17.3603 25.2474L15.7766 26.1576C15.5061 26.3131 15.5112 26.6999 15.7855 26.8485C17.9619 28.0289 19.298 28.6934 20.4463 28.9059Z",
    fill: "#FEC7AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0377 21.888H18.544C16.0072 21.888 13.9507 19.8627 13.9507 17.3643V13.0494H25.6309V17.3643C25.631 19.8627 23.5745 21.888 21.0377 21.888Z",
    fill: "#FFB59E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9487 13.9592C12.8434 13.9663 11.9492 14.8515 11.9492 15.9413C11.9492 17.0358 12.8506 17.9235 13.9619 17.9235L13.9487 13.9592Z",
    fill: "#FFB59E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6406 17.9235C26.7519 17.9235 27.6533 17.0358 27.6533 15.9413C27.6533 14.8469 26.7519 13.9592 25.6406 13.9592V17.9235Z",
    fill: "#FFB59E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1339 21.8875H18.5425C16.0059 21.8875 13.9492 19.862 13.9492 17.3639V13.049H15.5406V17.3639C15.5406 19.862 17.5973 21.8875 20.1339 21.8875Z",
    fill: "#FEC7AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6142 6.81006H16.9635C15.2985 6.81006 13.9487 8.13939 13.9487 9.77915V13.049H25.629V9.77915C25.629 8.13939 24.2792 6.81006 22.6142 6.81006Z",
    fill: "#4DAADD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5548 6.81006C16.8902 6.81006 15.5401 8.13907 15.5401 9.77902V13.0489H13.9487V9.77902C13.9487 8.13907 15.2988 6.81006 16.9634 6.81006H18.5548Z",
    fill: "#99DDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindADoctor);
export default __webpack_public_path__ + "static/media/FindADoctor.97247c3460c7d1ca1e2a06a89b322666.svg";
export { ForwardRef as ReactComponent };